import Typography from '@mui/material/Typography'
import { PageTitleProps } from './types'

export default function PageTitleMui( { title }: PageTitleProps ) {
	return <Typography variant="h1">{title}</Typography>
}
